// Utils
import hasRole from './hasRole'

// Constants
import {
  ROLE_ELVYRA_TECH,
} from '../constants'

// Exports
export default hasRole(ROLE_ELVYRA_TECH)
